import OtherItem from "../otheritems/OtherItem";
import { friedItems,combos } from "../services/ItemsApi";
import './FriedItems.css'
import FriedItem from "./FriedItem";

const FriedItemsDisplay = ({type}) => {
    const listitems = type==="Combos"? combos():friedItems();
   
    return listitems.map((item,index)=><FriedItem key={item.subtitle} item={item}/>)
        
    
}
 
export default FriedItemsDisplay;